import { render, staticRenderFns } from "./ProfileSettingsElement.vue?vue&type=template&id=1441c5fd&scoped=true"
import script from "./ProfileSettingsElement.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsElement.vue?vue&type=script&lang=js"
import style0 from "./ProfileSettingsElement.vue?vue&type=style&index=0&id=1441c5fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1441c5fd",
  null
  
)

export default component.exports